import common from "../helpers/common";

export default {
  computed: {
    getNow() {
      return common.getNow();
    },
    getNowUTC() {
      return common.getNowUTC();
    },
  },
  methods: {
    momentTz(date) {
      return common.momentTz(date);
    },
    formatDateTime(momentObject) {
      return common.formatDateTime(momentObject);
    },
    formatPrice(value) {
      return Number(value).toFixed(2);
    },
  },
};
